import {
  ButtonNormalSecondaryMedium,
  ButtonWrapper,
  SectionCenter,
  TitleAndDescription,
} from '@ferreri/prever-component-lib';

export const TalkWithConsultant = () => {
  const handleRedirectToWhatsapp = () => {
    window.open(
      `https://api.whatsapp.com/send/?phone=%2B558000016688&text=Ol%C3%A1%2C+eu+gostaria+de+mais+informa%C3%A7%C3%B5es+sobre+os+planos&type=phone_number&app_absent=0`,
      '_blank',
      'noopener noreferrer',
    );
  };

  return (
    <SectionCenter>
      <TitleAndDescription
        title="Quer falar com um consultor?"
        description="Entre em contato conosco pelo Whatsapp que iremos tirar todas as suas dúvidas. "
      />
      <ButtonWrapper onClick={handleRedirectToWhatsapp}>
        <ButtonNormalSecondaryMedium>
          Falar com consultor pelo Whatsapp
        </ButtonNormalSecondaryMedium>
      </ButtonWrapper>
    </SectionCenter>
  );
};
